import { APP_VERSION } from '@/utils/utils';

type FooterProps = {
  className?: string;
};

export default function Footer({ className = '' }: FooterProps) {
  return (
    <footer
      className={`mx-4 mb-4 mt-6 rounded-2xl border border-orange-100 bg-white/70 py-3 text-center text-xs font-medium text-stone-500 backdrop-blur ${className}`}
    >
      Lifebit Dashboard · v{APP_VERSION} — © {new Date().getFullYear()} Shark Technology
    </footer>
  );
}
